/* eslint-disable import/prefer-default-export */
  /* istanbul ignore next */
export const capitalizePhrase = (text) => {
  const textLowerCase = `${text.toLowerCase()} `;
  return textLowerCase
    .split(' ')
    .map((el) => el.charAt(0).toUpperCase() + el.slice(1))
    .join(' ')
    .trim();
};
  /* istanbul ignore next */
export const insertStringAfterBeforeCharOrString = (
  mainString,
  insertString,
  charOrWordToSearch,
  strict = true
) => {
  const position = strict
    ? mainString.indexOf(charOrWordToSearch)
    : mainString.toLocaleLowerCase().indexOf(charOrWordToSearch.toLocaleLowerCase());
  
  if (position !== -1) {
    return `${mainString.slice(0, position)}${insertString}${mainString.slice(position)}`;
  }
  return mainString;
};
/* istanbul ignore next */
export const getAlphanumericRandomString = (length) => {
  if (length === 0) return '';
  
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  
  let cryptoAPI;

  // 1. Priorizamos el navegador (Window)
  /* istanbul ignore next */
  if (typeof window !== 'undefined' && window.crypto) {
    cryptoAPI = window.crypto;
  } else {
    // 2. Fallback para Node.js (Tests unitarios)
    // Deshabilitamos la regla de linter solo para esta línea
    // eslint-disable-next-line global-require, import/no-dynamic-require
    cryptoAPI = require('crypto').webcrypto;
  }
  
  const randomValues = new Uint32Array(length);
  
  // Verificamos que cryptoAPI exista para evitar crashes raros
  /* istanbul ignore next */
  if (cryptoAPI) {
    cryptoAPI.getRandomValues(randomValues);
  } else {
    // Fallback de emergencia por si el entorno es muy antiguo (evita error fatal)
    return ''; 
  }
    /* istanbul ignore next */
  let result = '';
  for (let i = 0; i < length; i += 1) {
    const randomIndex = randomValues[i] % charactersLength;
    result += characters.charAt(randomIndex);
  }
  return result;
};